import React, { useEffect, useState } from "react";
import {
  updateFormContentPreview,
  getFormContentPreview,
  imageUploadClientPreview,
} from "../../../../api/services/services";
import { Button, Snackbar } from "@mui/material";
import Typography from "@mui/material/Typography";
import { Row, Col } from "react-bootstrap";
import MuiAlert from "@mui/material/Alert";
import { Bucket } from "../../../../api/config/apiConfig";
import Input from "../../../atoms/Input";
import TextArea from "../../../atoms/Textarea";
import ContactDetailField from "../../../molecules/ContactDetailField";
import { useLocation } from "react-router-dom";
import generatePDF, { Resolution, Margin } from "react-to-pdf";
// import QuotationFormDownload from "./download";
import html2pdf from "html2pdf.js";
import CustomCheckbox from "../../../atoms/CustomCheckbox";
import DynamicText from "../../../molecules/DynamicText";

const CrewInstructionDownload = ({ surveyData, formContent }) => {
  const [isEdit, setIsEdit] = useState(false);

  const getOrdinalSuffix = (day) => {
    if (day > 3 && day < 21) return "th"; // 11th, 12th, 13th, etc.
    switch (day % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };

  // Helper function to format the date
  const formatDate = (dateString) => {
    const date = new Date(dateString);

    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "long" });
    const year = date.getFullYear();

    const ordinalSuffix = getOrdinalSuffix(day);

    return `${day}${ordinalSuffix} ${month}, ${year}`;
  };

  return (
    <div className="premium-print-container">
      {/* header */}
      <div className="print-header d-flex justify-content-between align-items-center mb-4">
        <div>
          <h1 className="print-title" style={{ margin: 0, color: 'var(--primary-color)', fontSize: '24pt', fontWeight: 800 }}>SHELOZON</h1>
          <p className="print-subtitle" style={{ margin: 0, color: '#64748b', fontSize: '12pt' }}>Crew Instruction Document</p>
        </div>
        <div className="print-id-box" style={{ textAlign: 'right' }}>
          <span style={{ display: 'block', fontSize: '10pt', color: '#94a3b8' }}>File Ref</span>
          <span style={{ fontSize: '12pt', fontWeight: 700, color: '#0f172a' }}>{formContent?.fielRef || "-"}</span>
        </div>
      </div>

      {/* crew Details */}
      <div className="data-grid-premium mb-4" style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '20px', background: '#f8fafc', padding: '24px', borderRadius: '16px' }}>
        <div className="data-item">
          <span className="data-label" style={{ display: 'block', fontSize: '9pt', color: '#64748b', fontWeight: 600, textTransform: 'uppercase', marginBottom: '4px' }}>Customer Name</span>
          <span className="data-value" style={{ fontSize: '11pt', fontWeight: 700, color: '#1e293b' }}>{formContent?.customerName || "-"}</span>
        </div>
        <div className="data-item">
          <span className="data-label" style={{ display: 'block', fontSize: '9pt', color: '#64748b', fontWeight: 600, textTransform: 'uppercase', marginBottom: '4px' }}>Organization</span>
          <span className="data-value" style={{ fontSize: '11pt', fontWeight: 700, color: '#1e293b' }}>{formContent?.organization || "-"}</span>
        </div>
        <div className="data-item">
          <span className="data-label" style={{ display: 'block', fontSize: '9pt', color: '#64748b', fontWeight: 600, textTransform: 'uppercase', marginBottom: '4px' }}>Date</span>
          <span className="data-value" style={{ fontSize: '11pt', fontWeight: 700, color: '#1e293b' }}>{formContent?.date ? formatDate(formContent?.date) : "-"}</span>
        </div>
        <div className="data-item" style={{ gridColumn: 'span 3' }}>
          <span className="data-label" style={{ display: 'block', fontSize: '9pt', color: '#64748b', fontWeight: 600, textTransform: 'uppercase', marginBottom: '4px' }}>Origin Address</span>
          <span className="data-value" style={{ fontSize: '11pt', fontWeight: 500, color: '#1e293b' }}>{formContent?.originAddress || "-"}</span>
        </div>
        <div className="data-item" style={{ gridColumn: 'span 3' }}>
          <span className="data-label" style={{ display: 'block', fontSize: '9pt', color: '#64748b', fontWeight: 600, textTransform: 'uppercase', marginBottom: '4px' }}>Destination Address</span>
          <span className="data-value" style={{ fontSize: '11pt', fontWeight: 500, color: '#1e293b' }}>{formContent?.destinationAddress || "-"}</span>
        </div>
      </div>

      {/* Description of Services */}
      <div className="section-header-print" style={{ borderLeft: '4px solid var(--primary-color)', paddingLeft: '12px', marginBottom: '16px' }}>
        <h2 className="section-title" style={{ margin: 0, fontSize: '14pt', fontWeight: 800, color: '#0f172a' }}>Description of Services</h2>
      </div>
      <div style={{ backgroundColor: '#fff', border: '1px solid #e2e8f0', borderRadius: '16px', padding: '16px', marginBottom: '24px' }}>
        <div className="row crew px-2">
          {[
            { id: "preMoveSurvey", label: "Pre Move Survey", val: formContent?.preMoveSurcey },
            { id: "localMove", label: "Local Move", val: formContent?.localMove },
            { id: "InternationalMove", label: "International Move", val: formContent?.internationalMove },
            { id: "Road", label: "Road", val: formContent?.road },
            { id: "Assembling", label: "Assembling", val: formContent?.assembling },
            { id: "debrisRemoval", label: "Debris Removal", val: formContent?.debrisRemoval },
            { id: "Payments", label: "Payments", val: formContent?.payments },
            { id: "Documents", label: "Documents", val: formContent?.documents },
            { id: "Air", label: "Air", val: formContent?.air },
            { id: "Unloading", label: "Unloading", val: formContent?.unloading },
            { id: "Loading", label: "Loading", val: formContent?.loading },
            { id: "Invoice", label: "Invoice", val: formContent?.invoice },
            { id: "Delivery", label: "Delivery", val: formContent?.delivery },
            { id: "Sea", label: "Sea", val: formContent?.sea },
            { id: "Packing", label: "Packing", val: formContent?.packing },
            { id: "Unpacking", label: "Unpacking", val: formContent?.unpacking }
          ].map(item => (
            <div className="col-3 mb-1" key={item.id}>
              <CustomCheckbox
                style="mb-0"
                id={item.id}
                label={item.label}
                value={item.val}
                path={""}
                disabled={true}
              />
            </div>
          ))}
        </div>
      </div>

      {/* date and time*/}
      <div className="section-header-print" style={{ borderLeft: '4px solid var(--primary-color)', paddingLeft: '12px', marginBottom: '16px' }}>
        <h2 className="section-title" style={{ margin: 0, fontSize: '14pt', fontWeight: 800, color: '#0f172a' }}>Schedule Info</h2>
      </div>
      <div className="data-grid-premium mb-4" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', background: '#f8fafc', padding: '24px', borderRadius: '16px' }}>
        <div className="data-item">
          <span className="data-label" style={{ display: 'block', fontSize: '9pt', color: '#64748b', fontWeight: 600, textTransform: 'uppercase', marginBottom: '4px' }}>Job Start</span>
          <span className="data-value" style={{ fontSize: '11pt', fontWeight: 700, color: '#1e293b' }}>
            {formContent?.jobStartDate ? formatDate(formContent?.jobStartDate) : "-"} 
            {formContent?.jobStartTime ? ` at ${formContent?.jobStartTime}` : ""}
          </span>
        </div>
        <div className="data-item">
          <span className="data-label" style={{ display: 'block', fontSize: '9pt', color: '#64748b', fontWeight: 600, textTransform: 'uppercase', marginBottom: '4px' }}>Job End</span>
          <span className="data-value" style={{ fontSize: '11pt', fontWeight: 700, color: '#1e293b' }}>
            {formContent?.jobEndDate ? formatDate(formContent?.jobEndDate) : "-"}
            {formContent?.jobEndTime ? ` at ${formContent?.jobEndTime}` : ""}
          </span>
        </div>
      </div>

      {/* Remarks */}
      {formContent?.exclusions?.trim()?.length > 0 && (
        <div className="mb-4">
           <div className="section-header-print" style={{ borderLeft: '4px solid var(--primary-color)', paddingLeft: '12px', marginBottom: '16px' }}>
             <h2 className="section-title" style={{ margin: 0, fontSize: '14pt', fontWeight: 800, color: '#0f172a' }}>Remarks</h2>
           </div>
           <div style={{ backgroundColor: '#fffbeb', borderLeft: '4px solid #f59e0b', padding: '16px', borderRadius: '12px' }}>
             <p className="p-word" style={{ fontSize: '11pt', color: '#92400e', margin: 0 }}>
               {formContent?.exclusions}
             </p>
           </div>
        </div>
      )}

      {/* Signatures */}
      <div className="mt-5 pt-4" style={{ pageBreakInside: 'avoid' }}>
        <Row>
          <Col sm={6} className="text-center">
            <div style={{ height: "100px", borderBottom: '2px solid #f1f5f9', marginBottom: '12px', backgroundColor: '#fff' }} className="d-flex justify-content-center align-items-center">
              {formContent?.moveCordinatorSign?.trim()?.length > 0 && (
                <img src={`${Bucket}${formContent?.moveCordinatorSign}`} height={80} style={{ objectFit: 'contain' }} />
              )}
            </div>
            <p className="mb-0" style={{ fontSize: '10pt', fontWeight: 800, color: '#1e293b', textTransform: 'uppercase' }}>Move Coordinator</p>
            <span style={{ fontSize: '8pt', color: '#94a3b8' }}>Authorized Signature</span>
          </Col>
          <Col sm={6} className="text-center">
            <div style={{ height: "100px", borderBottom: '2px solid #f1f5f9', marginBottom: '12px', backgroundColor: '#fff' }} className="d-flex justify-content-center align-items-center">
              {formContent?.packingManagerSign?.trim()?.length > 0 && (
                <img src={`${Bucket}${formContent.packingManagerSign}`} height={80} style={{ objectFit: 'contain' }} />
              )}
            </div>
            <p className="mb-0" style={{ fontSize: '10pt', fontWeight: 800, color: '#1e293b', textTransform: 'uppercase' }}>Packing Manager</p>
            <span style={{ fontSize: '8pt', color: '#94a3b8' }}>Authorized Signature</span>
          </Col>
        </Row>
      </div>
      
      <div className="print-footer" style={{ marginTop: '50px', borderTop: '1px solid #f1f5f9', paddingTop: '20px', textAlign: 'center' }}>
         <p style={{ fontSize: '9pt', color: '#94a3b8', margin: 0 }}>SHELOZON - Reliability Redefined</p>
      </div>
    </div>
  );
};

export default CrewInstructionDownload;
